import { Anchor, Badge, Button, Card, Flex, Grid, Skeleton, Stack, Text, Tooltip } from '@mantine/core';
import { IconChartLine, IconHistory } from '@tabler/icons-react';
import { useParams } from 'react-router';

const statusColor = { active: 'green', inactive: 'gray', draft: 'yellow' };

const NPSSurveyCard = ({ npsSurvey, score }) => {
  const { accountId, domainId } = useParams();

  return (
    <Card mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid align="center">
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Anchor href={`#/accounts/${accountId}/domains/${domainId}/nps/${npsSurvey.id}/details`} fw={600} style={{ display: 'block' }}>
              {npsSurvey.name}
            </Anchor>
            <Flex gap="xs" mt="xs" align="center">
              <Badge color={statusColor[npsSurvey.status] || 'gray'} variant="light">
                {npsSurvey.status}
              </Badge>
              <Tooltip
                label={
                  <Stack gap={2}>
                    <Text size="xs">Created: {npsSurvey.createdAt ? new Date(npsSurvey.createdAt).toLocaleString() : 'Unknown'}</Text>
                    <Text size="xs">Updated: {npsSurvey.updatedAt ? new Date(npsSurvey.updatedAt).toLocaleString() : 'Unknown'}</Text>
                  </Stack>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 4 }} ta="center">
            {score === undefined ? (
              <Skeleton height={36} width={80} mx="auto" />
            ) : score != null ? (
              <>
                <Text size="xl" fw={700} c={score >= 50 ? 'green' : score >= 0 ? 'yellow' : 'red'}>
                  {score > 0 ? `+${score}` : score}
                </Text>
                <Text size="xs" c="dimmed">
                  NPS Score
                </Text>
              </>
            ) : (
              <Text size="sm" c="dimmed">
                No responses yet
              </Text>
            )}
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end">
              <Button
                component="a"
                href={`#/accounts/${accountId}/domains/${domainId}/nps/${npsSurvey.id}/analytics`}
                size="xs"
              >
                Analytics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default NPSSurveyCard;
